// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M6.75 3H12.5M3.5 13H9.25M9.6 3L6.4 13'];
